module.exports = __webpack_public_path__ + "static/media/Biswajeet Pasayat.2165fe0b.jpg";